import React, { Component } from 'react'
import { debounce } from 'lodash'
import { connect } from 'react-redux'
import IconRight from '../svg/icon-right'
import IconWrong from '../svg/icon-wrong'
import './icons.css'

class Holder extends Component {
  state = {
    height: window.innerHeight
  }

  constructor(props) {
    super(props)
    this.resize = this.resize.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize)
  }

  resize = debounce(() => {
    this.setState({
      height: window.innerHeight
    })
  }, 100)

  render() {
    const { answered, response } = this.props
    const { height } = this.state
    const card = height > 650 ? 450 : 335
    const top = Math.max(108, (height - card) / 2)

    const Icon =
      response === 0 ? (
        <div className="answer-icon answer-right" style={{ top }}>
          <IconRight />
        </div>
      ) : (
        <div className="answer-icon answer-wront" style={{ top }}>
          <IconWrong />
        </div>
      )

    return answered ? Icon : null
  }
}
const mapState = state => {
  const { icons } = state
  const { answered, response } = icons
  return {
    answered,
    response
  }
}

export default connect(mapState)(Holder)



// WEBPACK FOOTER //
// ./src/components/Icons.js